import CustomerIndex from './Index'
import CustomerView from './View'
import CustomerGeneralTab from './tab/General'
import CustomerEnergeticsTab from './tab/Energetics'
import CustomerDocuments from './tab/Documents'
import CustomerHistory from './tab/History'
import CustomerEnergeticsDetail from '../energetics/customer/Index'
import CustomerEnergeticsContractTab from '../energetics/customer/tabs/contract/Index'
import CustomerEnergeticsTechnicalTab from '../energetics/customer/tabs/technical/Index'
import CustomerEnergeticsDeviceTab from '../energetics/customer/tabs/device/Index'
import CustomerEnergeticsTimeTab from '../energetics/customer/tabs/time/Index'

export default [
  {
    path: '/customer',
    name: 'customer',
    component: CustomerIndex,
    meta: {
      auth: true,
      permission: 'view',
    },
    children: [
      {
        path: ':id',
        name: 'customerView',
        redirect: '/customer/:id/general',
        component: CustomerView,
        children: [
          {
            path: 'general',
            name: 'customerGeneral',
            component: CustomerGeneralTab,
          },
          {
            path: 'energetics/:energetics_id',
            name: 'customerEnergetics',
            redirect: 'energetics/:energetics_id',
            component: CustomerEnergeticsTab,
            children: [
              {
                path: '',
                name: 'customerEnergeticsDetail',
                component: CustomerEnergeticsDetail,
              },
              {
                path: 'contract',
                name: 'customerEnergeticContractTab',
                component: CustomerEnergeticsContractTab,
              },
              {
                path: 'technical',
                name: 'customerEnergeticTechnicalTab',
                component: CustomerEnergeticsTechnicalTab,
                alias: '',
              },
              {
                path: 'device',
                name: 'customerEnergeticDeviceTab',
                component: CustomerEnergeticsDeviceTab,
              },
              {
                path: 'time',
                name: 'customerEnergeticTimeTab',
                component: CustomerEnergeticsTimeTab,
              },
            ],
          },
          {
            path: 'documents',
            name: 'customerDocuments',
            component: CustomerDocuments,
            children: [
              {
                path: ':path*',
                name: 'customerDocumentsPath',
                meta: {
                  parent_id: null,
                },
              },
            ],
          },
          {
            path: 'history',
            name: 'customerHistory',
            component: CustomerHistory,
          },
        ],
      },
    ],
  },
]
